<template>
<v-container fluid fill-height>
    <v-layout v-if="loading" align-center justify-center>
        <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
    <v-layout v-else>
        <v-flex xs12>
            <v-card>
                <v-toolbar color="primary" class="white--text">
                    <v-toolbar-title>Allowance Types</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon dark>layers</v-icon>
                </v-toolbar>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-alert :value="error != null" outline type="error">
                            {{error}}
                        </v-alert>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-text-field v-model="search" append-icon="search" label="Filter" single-line hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-checkbox class="active-checkbox" label="Active Only" v-model="activeOnly" hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm1>
                        <v-btn color="primary" block @click="showEditAddAllowanceType({Active: true})">
                            Add
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout pt-3>
                    <v-flex xs12>
                        <AllowanceTypeTable :search="search" :filteredItems="filteredItems" @edit="showEditAddAllowanceType($event)"></AllowanceTypeTable>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog 
        :value="editing"
        fullscreen 
        hide-overlay 
        transition="dialog-bottom-transition">
        <AllowanceTypeEdit 
            v-if="editing"
            :item="editItem"
            :submitLoading="loading"
            :submitError="error"
            @submit="handleSubmit"
            @cancel="cancelEdit()">
        </AllowanceTypeEdit>
    </v-dialog>
</v-container>
</template>

<script>
import AllowanceTypeTable from "@/components/configuration/allowances/AllowanceTypeTable.vue";
import AllowanceTypeEdit from "@/components/configuration/allowances/AllowanceTypeEdit.vue";

import AllowanceTypeAPI from "@/api/allowanceTypeAPI";

export default {
    components: {
        AllowanceTypeTable: AllowanceTypeTable,
        AllowanceTypeEdit: AllowanceTypeEdit
    },
    data() {
        return {
            editing: false,
            error: null,
            loading: false,
            search: "",
            activeOnly: true,
            editItem: null,
            allowanceTypes: []
        }
    },
    computed: {
        filteredItems() {
            return this.allowanceTypes.filter(at => at.Active || !this.activeOnly);
        }
    },
    methods: {
        async loadAllowanceTypes() {
            this.error = null;

            try {
                this.loading = true;

                this.allowanceTypes = await AllowanceTypeAPI.getAllowanceTypes();
            }
            catch (err) {
                this.error = err;
            }
            finally {
                this.loading = false;
            }
        },
        showEditAddAllowanceType(item) {            
            this.editItem = item;
            this.editing = true;
        },
        cancelEdit() {
            this.editItem = null;
            this.error = null;
            this.editing = false;
        },
        async handleSubmit(item) {
            this.loading = true;            

            try {
                await AllowanceTypeAPI.saveAllowanceType(item);

                this.editing = false;

                await this.loadAllowanceTypes();
            }
            catch (err) {
                this.error = err;
                return;

            }
            finally {
                this.loading = false;
            }
        }
    },
    async created() {
        await this.loadAllowanceTypes();
    }
}
</script>
